<!-- 走进我们 new -->
<template>
  <div class="template-container">
    <div class="container-main">
      <div class="main-top-box">
        <div class="img-top-back"><div class="back-text">{{ $t("about_index.text1") }}</div></div>
        <img class="img-top" src="/static/images/industry/hw600/section6.png" />
      </div>
      <div>
        <div class="main-text1">{{ $t("about_index.text12") }} > {{ $t("about_index.text1") }} </div>
        <div class="main-text2">{{ $t("about_index.text2") }}</div>
        <div class="main-text3">
          {{ $t("about_index.text3") }}
        </div>
        <img
          class="img-details-box"
          src="/static/images/about/about/daqing.png"
        />
      </div>
      <div class="img-details-box2">
        <div class="img-box2-back">
          <div class="back-text2">
            {{ $t("about_index.text4") }}<br> {{ $t("about_index.text4-1") }}
          </div>
        </div>
        <img class="img-top2" src="/static/images/about/about/green.png" />
      </div>
      <div style="max-width: 100%;text-align: center;">
        <div class="main-title">{{ $t("about_index.text5-1") }}</div>
        <div class="main-title-line"></div>
        <div class="main-grid-box">
          <div class="main-grid-item">
            <img class="grid-img" src="/static/images/about/about/lx_yf.png" />
            <div class="grid-box">
              <div class="grid-title">{{ $t("about_index.list")[0].title }}</div>
              <div class="grid-text">{{ $t("about_index.list")[0].desc }}</div>
            </div>
          </div>
          <div class="main-grid-item">
            <img class="grid-img" src="/static/images/about/about/lx_xs.png" />
            <div class="grid-box">
              <div class="grid-title">{{ $t("about_index.list")[1].title }}</div>
              <div class="grid-text">{{ $t("about_index.list")[1].desc }}</div>
            </div>
          </div>
          <div class="main-grid-item">
            <img class="grid-img" src="/static/images/about/about/lx_fw.png" />
            <div class="grid-box">
              <div class="grid-title">{{ $t("about_index.list")[2].title }}</div>
              <div class="grid-text">{{ $t("about_index.list")[2].desc }}</div>
            </div>
          </div>
          <div class="main-grid-item">
            <img class="grid-img" src="/static/images/about/about/lx_odm.png" />
            <div class="grid-box">
              <div class="grid-title">{{ $t("about_index.list")[3].title }}</div>
              <div class="grid-text">{{ $t("about_index.list")[3].desc }}</div>
            </div>
          </div>
        </div>
        <img
          class="img-details-box3"
          src="/static/images/about/about/mb7.png"
        />
      </div>
      <div class="main-center-box">
        <div class="main-center-title">{{ $t("about_index.text6") }}</div>
        <router-link class="main-center-text"  to="/company">
          
          {{ $t("about_index.text7") }}
          <img
            class="main-center-img"
            src="/static/images/about/about/jiantou13.png"
          />
        </router-link>
      </div>
      <div>
        <div class="main-title">{{ $t("about_index.text8") }}</div>
        <div class="main-text3">
          {{ $t("about_index.text9") }}
        </div>
        <img class="img-list"  src="/static/images/about/about/banner3.png"/>
        <div class="main-title">{{ $t("about_index.text10") }}</div>
        <div class="main-text3">
          {{ $t("about_index.text11") }}
        </div>
        <img class="img-bottom"  src="/static/images/about/about/banner2.png"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsData: [],
    };
  },
  created() {},
};
</script>

<style lang='stylus' scoped>
.template-container {
  width: 100%;
  max-width: 1920px;
  min-width :1296px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  background: #fff;

  .container-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .main-top-box {
      width: 100%;
      max-width: 1920px;
      max-height: 600px;

      .img-top {
        object-fit: cover;
        width: 100%;
        max-width: 1920px;
        height: 600px;
      }

      .img-top-back {
        z-index: 10;
        opacity: 1;
        position: absolute;
        width: 100%;
        max-width: 1920px;
        min-width :1296px;
        height: 600px;
        background: linear-gradient(180deg, rgba(3, 78, 174, 0.43) 0%, rgba(89, 98, 110, 0.49) 100%);
        text-align: center;
        font-size: 34px;
        font-weight: 500;
        color: #FFFFFF;

        .back-text {
          margin-top: 327px;
        }
      }

      .img-text {
        height: 144px;
      }
    }

    .main-text1 {
      margin-top: 20px;
      font-size: 12px;
      font-weight: 500;
      line-height: 29px;
      color: #3D3D3D;
    }

    .main-text2 {
      margin-top: 64px;
      font-size: 36px;
      font-weight: 500;
      line-height: 29px;
      color: #1F416B;
    }

    .main-text3 {
      max-width: 1280px;
      margin-top: 20px;
      margin-bottom: 41px;
      font-size: 16px;
      font-weight: 500;
      line-height: 26px;
      color: #666;
    }

    .img-details-box {
      width: 1296px;
      height: 540px;
      object-fit: cover;
    }

    .img-details-box2 {
      margin-top: 91px;
      width: 100%;
      max-width: 1920px;
      max-height: 599px;

      .img-top2 {
        object-fit: cover;
        width: 100%;
        max-width: 1920px;
        height: 599px;
      }

      .img-box2-back {
        z-index: 10;
        opacity: 1;
        position: absolute;
        width: 100%;
        max-width: 1920px;
        min-width :1296px;
        height: 599px;
        background: linear-gradient(180deg, rgba(30, 82, 149, 0.43) 0%, rgba(30, 82, 149, 0.49) 100%);
        text-align: center;
        font-size: 34px;
        font-weight: 500;
        color: #FFFFFF;

        .back-text2 {
          margin-top: 249px;
          white-space: pre-wrap;
          line-height: 60px;
        }
      }
    }

    .main-title {
      font-size: 24px;
      font-weight: 500;
      line-height: 52px;
      color: #1E5295;
      width: 1280px;
      margin-top: 150px;
    }

    .main-title-line {
      width: 1280px;
      height: 1px;
      background: #D8D8D8;
      margin: 18px 0px 60px 0px;
    }

    .main-grid-box {
      display: grid;
      margin-top: 60px;
      grid-template-columns: 25% 25% 25% 25%;
      width: 1280px;

      .main-grid-item {
        display: flex;

        .grid-img {
          width: 54px;
          height: 54px;
          margin-right: 18px;
        }

        .grid-box {
          .grid-title {
            font-size: 24px;
            font-weight: 500;
            line-height: 36px;
            color: #111111;
          }

          .grid-text {
            width: 200px;
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #666666;
          }
        }
      }
    }

    .img-details-box3 {
      margin-top: 17px;
      width: 1280px;
      height: 495px;
      object-fit: cover;
    }

    .main-center-box {
      margin-top: 90px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 1920px;
      height: 220px;
      background: #1E5295;

      .main-center-title {
        font-size: 24px;
        font-weight: 500;
        line-height: 60px;
        text-align: center;
        color: #FFFFFF;
      }

      .main-center-text {
        margin-top: 20px;
        padding-left: 39px;
        padding-right: 4px;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 44px;
        background: #007BE7;

        .main-center-img {
          width: 40px;
          height: 40px;
        }
      }
    }
    .img-list{
      width: 1280px;
      height: 537px;
    }
    .img-bottom{
      object-fit: cover;
      width: 1280px;
      height: 600px;
      margin-bottom: 234px;
    }
  }
}

// 移动端
@media all and (min-width: 320px) and (max-width: 768px) {
  .template-container {
    min-width :80px;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    box-sizing: border-box;
    background: #fff;
  
    .container-main {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
  
      .main-top-box {
        width: 100%;
        max-height: 600px;
  
        .img-top {
          object-fit: cover;
          width: 100%;
          height: 300px;
        }
  
        .img-top-back {
          z-index: 10;
          opacity: 1;
          position: absolute;
          width: 100%;
          height: 300px;
          max-width: 100%;
          min-width :80%;
          background: linear-gradient(180deg, rgba(3, 78, 174, 0.43) 0%, rgba(89, 98, 110, 0.49) 100%);
          text-align: center;
          font-size: 34px;
          font-weight: 500;
          color: #FFFFFF;
  
          .back-text {
            margin-top: 127px;
          }
        }
  
        .img-text {
          height: 144px;
        }
      }
  
      .main-text1 {
        width: 90%;
        padding: 0px 5% 0px 5%;
        margin-top: 20px;
        font-size: 12px;
        font-weight: 500;
        line-height: 29px;
        color: #3D3D3D;
      }
  
      .main-text2 {
        width: 90%;
        padding: 0px 5% 0px 5%;
        margin-top: 64px;
        font-size: 36px;
        font-weight: 500;
        line-height: 29px;
        color: #1F416B;
      }
  
      .main-text3 {
        padding: 0px 5% 0px 5%;
        width: 90%;
        margin-top: 20px;
        margin-bottom: 41px;
        font-size: 16px;
        font-weight: 500;
        line-height: 26px;
        color: #666;
      }
  
      .img-details-box {
        width: 100%;
        height: 240px;
        object-fit: cover;
      }
  
      .img-details-box2 {
        margin-top: 91px;
        width: 100%;
        max-width: 1920px;
        max-height: 599px;
  
        .img-top2 {
          object-fit: cover;
          width: 100%;
          max-width: 1920px;
          height: 309px;
        }
  
        .img-box2-back {
          z-index: 10;
          opacity: 1;
          position: absolute;
          width: 100%;
          max-width: 100%;
          min-width :80%;
          height: 309px;
          background: linear-gradient(180deg, rgba(30, 82, 149, 0.43) 0%, rgba(30, 82, 149, 0.49) 100%);
          text-align: center;
          font-size: 20px;
          font-weight: 500;
          color: #FFFFFF;
  
          .back-text2 {
            text-align: center;
            margin-top: 59px;
            white-space: pre-wrap;
            line-height: 30px;
          }
        }
      }
  
      .main-title {
        width: 90%;
        font-size: 20px;
        font-weight: 500;
        line-height: 52px;
        color: #1E5295;
        padding: 0px 5% 0px 5%;
        margin-top: 50px;
      }
  
      .main-title-line {
        width: 100%;
        height: 1px;
        background: #D8D8D8;
        margin: 18px 0px 60px 0px;
      }
  
      .main-grid-box {
        display: grid;
        margin-top: 60px;
        grid-template-columns: 50% 50% ;
        width: 100%;
  
        .main-grid-item {
          margin-top: 20px;
          width: 90%;
          .grid-img {
            width: 30px;
            height: 30px;
            margin-right: 18px;
          }
  
          .grid-box {
           
            .grid-title {
              font-size: 14px;
              font-weight: 500;
              line-height: 18px;
              color: #111111;
            }
            .grid-text {
              font-size: 12px;
              font-weight: 500;
              line-height: 14px;
              color: #666666;
              width: 100%;
            }
          }
        }
      }
  
      .img-details-box3 {
        margin-top: 17px;
        width: 100%;
        height: 205px;
        object-fit: cover;
      }
  
      .main-center-box {
        margin-top: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 220px;
        background: #1E5295;
  
        .main-center-title {
          font-size: 20px;
          font-weight: 500;
          line-height: 60px;
          text-align: center;
          color: #FFFFFF;
        }
  
        .main-center-text {
          margin-top: 20px;
          padding-left: 39px;
          padding-right: 4px;
          font-size: 16px;
          font-weight: 500;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 44px;
          background: #007BE7;
  
          .main-center-img {
            width: 40px;
            height: 40px;
          }
        }
      }
      .img-list{
        width: 100%;
        height: 60%;
      }
      .img-bottom{
        object-fit: cover;
        width: 100%;
        height: 60%;
        margin-bottom: 50px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about/index.vue